/* ==========================================================================
   Clippiq — ek mağaza davranışları
   Görsel büyüteci (lightbox), anlık arama, karttan hızlı sepete ekleme.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ======================================================================
     1. Ürün görseli büyüteci
     ====================================================================== */
  var lightbox = null;
  var lbImages = [];
  var lbIndex = 0;
  var lbOpener = null;

  function buildLightbox() {
    if (lightbox) return lightbox;
    lightbox = document.createElement('div');
    lightbox.className = 'clp-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Ürün görselleri');
    lightbox.innerHTML =
      '<button class="clp-lightbox__close" type="button" aria-label="Kapat">' +
        '<svg viewBox="0 0 16 16" fill="none"><path d="M2 2l12 12M14 2 2 14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<button class="clp-lightbox__nav clp-lightbox__nav--prev" type="button" aria-label="Önceki">' +
        '<svg viewBox="0 0 8 12" fill="none"><path d="M6.5 1 1.5 6l5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<button class="clp-lightbox__nav clp-lightbox__nav--next" type="button" aria-label="Sonraki">' +
        '<svg viewBox="0 0 8 12" fill="none"><path d="M1.5 1 6.5 6l-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<figure class="clp-lightbox__figure"><img alt=""></figure>' +
      '<div class="clp-lightbox__counter"></div>';
    document.body.appendChild(lightbox);

    $('.clp-lightbox__close', lightbox).addEventListener('click', closeLightbox);
    $('.clp-lightbox__nav--prev', lightbox).addEventListener('click', function () { step(-1); });
    $('.clp-lightbox__nav--next', lightbox).addEventListener('click', function () { step(1); });
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.classList.contains('clp-lightbox__figure')) closeLightbox();
    });
    return lightbox;
  }

  function render() {
    var img = $('.clp-lightbox__figure img', lightbox);
    var src = lbImages[lbIndex];
    img.classList.remove('is-in');
    window.requestAnimationFrame(function () {
      img.src = src.src;
      img.alt = src.alt || '';
      window.requestAnimationFrame(function () { img.classList.add('is-in'); });
    });
    $('.clp-lightbox__counter', lightbox).textContent = lbIndex + 1 + ' / ' + lbImages.length;
    var multi = lbImages.length > 1;
    $$('.clp-lightbox__nav', lightbox).forEach(function (b) { b.hidden = !multi; });
  }

  function step(dir) {
    lbIndex = (lbIndex + dir + lbImages.length) % lbImages.length;
    render();
  }

  function openLightbox(images, index, opener) {
    buildLightbox();
    lbImages = images;
    lbIndex = index;
    lbOpener = opener || document.activeElement;
    render();
    document.body.style.overflow = 'hidden';
    lightbox.classList.add('is-open');
    $('.clp-lightbox__close', lightbox).focus();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lbOpener && lbOpener.focus) lbOpener.focus();
  }

  document.addEventListener('keydown', function (e) {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowRight') step(1);
    if (e.key === 'ArrowLeft') step(-1);
  });

  document.addEventListener('click', function (e) {
    var slide = e.target.closest('[data-clp-gallery] .product__media-slide img');
    if (!slide) return;
    var gallery = slide.closest('[data-clp-gallery]');
    var imgs = $$('.product__media-slide img', gallery).map(function (i) {
      return { src: i.currentSrc || i.src, alt: i.alt };
    });
    var idx = $$('.product__media-slide img', gallery).indexOf(slide);
    openLightbox(imgs, Math.max(0, idx), slide);
  });

  /* ======================================================================
     2. Anlık arama önerileri
     ====================================================================== */
  var searchInput = $('#SearchDrawerInput');
  if (searchInput) {
    var results = document.createElement('div');
    results.className = 'clp-predictive';
    results.setAttribute('aria-live', 'polite');
    var drawer = searchInput.closest('.search-drawer');
    if (drawer) drawer.appendChild(results);

    var debounce = null;
    var lastQuery = '';

    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(debounce);
      if (q.length < 2) { results.innerHTML = ''; results.classList.remove('is-open'); return; }
      if (q === lastQuery) return;

      debounce = setTimeout(function () {
        lastQuery = q;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5', {
          headers: { Accept: 'application/json' }
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!items.length) {
              results.innerHTML = '<p class="clp-predictive__empty">Sonuç bulunamadı.</p>';
              results.classList.add('is-open');
              return;
            }
            results.innerHTML = items
              .map(function (p) {
                var img = p.featured_image && p.featured_image.url
                  ? '<img src="' + p.featured_image.url + '" alt="" width="56" height="56" loading="lazy">'
                  : '<span class="clp-predictive__ph"></span>';
                return (
                  '<a class="clp-predictive__item" href="' + p.url + '">' +
                  img +
                  '<span class="clp-predictive__info">' +
                  '<span class="clp-predictive__title">' + p.title + '</span>' +
                  '<span class="clp-predictive__price">' + (p.price || '') + '</span>' +
                  '</span></a>'
                );
              })
              .join('');
            results.classList.add('is-open');
          })
          .catch(function () { results.classList.remove('is-open'); });
      }, 220);
    });
  }

  /* ======================================================================
     3. Karttan hızlı sepete ekleme
     ====================================================================== */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var id = btn.getAttribute('data-quick-add');
    if (!id || !window.clpCart) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    var form = new FormData();
    form.append('id', id);
    form.append('quantity', 1);

    window.clpCart
      .add(form)
      .then(function () {
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1600);
      })
      .catch(function () {
        btn.classList.add('is-error');
        setTimeout(function () { btn.classList.remove('is-error'); }, 1600);
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  });
})();
